// extracted by mini-css-extract-plugin
export var bounce = "_pa-1";
export var generatingText = "_pa-6";
export var lightning = "_pa-4";
export var popup = "_pa-5";
export var progressBar = "_pa-7";
export var progressFill = "_pa-8";
export var progressShimmer = "_pa-9";
export var progressText = "_pa-a";
export var shimmer = "_pa-3";
export var uploadIcon = "_pa-0";
export var uploadingText = "_pa-2";